import { render, staticRenderFns } from "./advertising-add-or-update.vue?vue&type=template&id=1769d1df&"
import script from "./advertising-add-or-update.vue?vue&type=script&lang=js&"
export * from "./advertising-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports